type StatusValue =
  | 'NOT_STARTED'
  | 'DONE'
  | 'AVAILABLE'
  | 'ACTIVE'
  | 'COMPLETED'
  | 'PARTIALLY_AVAILABLE'
  | 'BOOKED'
  | 'APPROVED'
  | 'CONFIRMED'
  | 'DRAFT'
  | 'PENDING'
  | 'CANCELLED'
  | 'PRINT_PROOF_REQUIRED'
  | 'BLOCKED'
  | 'IN_PROGRESS'
  | 'SHIPPED'
  | 'IN_REVIEW'
  | 'NA'
  | 'REJECTED'
  | 'DELAYED';

export const getColorForStatus = (status: StatusValue, theme: any) => {
  switch (status) {
    case 'ACTIVE':
    case 'COMPLETED':
    case 'AVAILABLE':
    case 'APPROVED':
    case 'CONFIRMED':
    case 'DONE':
      return theme.palette.green[600];
    case 'BOOKED':
    case 'IN_PROGRESS':
    case 'IN_REVIEW':
    case 'SHIPPED':
    case 'REJECTED':
    case 'CANCELLED':
    case 'BLOCKED':
      return theme.palette.red[600];
    case 'NA':
    case 'DRAFT':
    case 'PARTIALLY_AVAILABLE':
    case 'PRINT_PROOF_REQUIRED':
    case 'DELAYED':
      return theme.palette.orange[600];
    default:
      return theme.palette.grey[600];
  }
};

export const getBackgroundColorForStatus = (status: StatusValue, theme: any) => {
  switch (status) {
    case 'ACTIVE':
    case 'COMPLETED':
    case 'AVAILABLE':
    case 'APPROVED':
    case 'CONFIRMED':
    case 'DONE':
      return theme.palette.green[100];
    case 'BOOKED':
    case 'IN_PROGRESS':
    case 'IN_REVIEW':
    case 'SHIPPED':
      return theme.palette.red[100];
    case 'REJECTED':
    case 'CANCELLED':
    case 'BLOCKED':
      return theme.palette.red[300];
    case 'DRAFT':
    case 'PARTIALLY_AVAILABLE':
    case 'PRINT_PROOF_REQUIRED':
    case 'NA':
    case 'DELAYED':
      return theme.palette.orange[100];
    default:
      return theme.palette.grey[100];
  }
};
